export default "__VITE_ASSET__rEOlbKXE__"